import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5289ef80")

_pushScopeId("data-v-5289ef80")
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "box-shift__button mb-4" }
const _hoisted_3 = { class: "storybook-button--large button-shift" }
const _hoisted_4 = { class: "overflow-auto" }
const _hoisted_5 = { class: "relative h-full -m-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", _hoisted_3, _toDisplayString(_ctx.t('shiftRegistration.buttonText')), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        headers: _ctx.shiftRegisterDataHeader,
        data: _ctx.shiftRegisterData
      }, {
        shift_pattern: _withId(({ item }) => [
          _createVNode(_component_Select, {
            modelValue: item.shift_pattern,
            "onUpdate:modelValue": ($event: any) => (item.shift_pattern = $event),
            class: "text-center",
            "options-select": _ctx.shiftPatternOptions,
            "item-value": "value",
            "item-text": "text",
            background: _ctx.onChoseColorRanDom
          }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "background"])
        ]),
        date: _withId(({ item }) => [
          _createVNode("div", {
            style: { color: _ctx.getColorDate(item.date) },
            class: "text-center"
          }, _toDisplayString(_ctx.displayDate(item.date)), 5)
        ]),
        target_time: _withId(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.displayTargetTime(item)), 1)
        ]),
        "9AM": _withId(({ item }) => [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", {
              class: "time-line",
              style: _ctx.styleTimeLine(item)
            }, null, 4)
          ])
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ])
  ]))
})